import React, { Component } from 'react';

import HttpUtil from '../../Util/httpUtil';
import Config from '../../Util/config';

import { AlertasContext } from '../../Providers/Alertas';
import { Button, Modal, ModalBody, Col, Row, Container } from 'reactstrap';

import './ModalToken.scss';

class ModalToken extends Component {
	constructor(props) {
		super(props);

		this.state = {
			backdrop: true,
			token: '',
			validarFormulario: false,
		};
	}

	handleTokenChange = event => {
		console.log("evento: "+event)
		this.setState({
			token: event.target.value,
			validarFormulario: event.target.value.length > 0,
		});
	};

	confirmar = event => {
		event.preventDefault();
		var url = `${Config.urls.API_URL_BASE}Acesso/ValidarToken/${this.state.token}`;

		return new Promise(() => {
			HttpUtil.eco_GET(url)
				.then(response => {
					if (!response.data) {
						this.showErrorMessage('O código informado não é um token válido.');
					} else {
						localStorage.setItem('CodUsuario', `39000${this.state.token}`);
						localStorage.setItem('Token', this.state.token);

						window.location.href = `/validar-login/39000${this.state.token}/true`;
					}
				})
				.catch(() => {
					window.location = '/erro';
				});
		});
	};

	componentDidMount() {
		this.inputToken.focus();
		//window.location.reload(true);
        //document.location.reload(true);
	}

	render() {
		return (
			<Modal id="modalToken" isOpen={true}>
				<ModalBody>
					<AlertasContext.Consumer>
						{alertas => {
							this.showInfoMessage = alertas.info;
							this.showSuccessMessage = alertas.success;
							this.showWarningMessage = alertas.warning;
							this.showErrorMessage = alertas.error;
						}}
					</AlertasContext.Consumer>
					<Container>
						<form onSubmit={this.confirmar}>
							<Row>
								<Col className="col-sm-10 col">
									<label>Preencha o Token</label>
								</Col>
							</Row>
							<Row>
								<Col>
									<input
										className="token"
										ref={input => {
											this.inputToken = input;
										}}
										onChange={this.handleTokenChange}
										placeholder="Digite o token fornecido pela Econet"
									/>
								</Col>
							</Row>
							<Row>
								<Col>
									<div className="text-center">
										<Button
											type="submit"
											className="btnEnviarFeedback btn-block"
											color="success"
											disabled={!this.state.validarFormulario}>
											Confirmar
										</Button>
									</div>
								</Col>
							</Row>
						</form>
					</Container>
				</ModalBody>
			</Modal>
		);
	}
}

export default ModalToken;
